import { useIsMobile } from '@ori/presentation-hooks';
import { Item } from './Item';
import { BreadcrumbsWrapper, StyledArrowLeftThin, StyledArrowRightThin, StyledLink, StyledWrapper } from './styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Breadcrumbs = ({
  breadcrumbs,
  disableMobileLayout = false
}) => {
  const isMobile = useIsMobile();
  const breadcrumbsLength = breadcrumbs.length;
  if (breadcrumbsLength < 1) {
    return null;
  }

  // on mobile penultimate item should be showed when there are more than 2 items
  // if there is only one item, this item should be showed
  const previousSection = breadcrumbsLength < 2 ? breadcrumbs[0] : breadcrumbs[breadcrumbsLength - 2];
  const {
    ItemLabel: lastName = '',
    Url: previousSectionUrl = ''
  } = previousSection ?? {};
  return /*#__PURE__*/_jsx(BreadcrumbsWrapper, {
    children: isMobile && !disableMobileLayout ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StyledArrowLeftThin, {}), /*#__PURE__*/_jsx(StyledLink, {
        isLast: true,
        isMobile: isMobile,
        href: previousSectionUrl,
        name: lastName,
        children: lastName
      })]
    }) : breadcrumbs.map(({
      ItemLabel,
      Url
    }, index) => /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(Item, {
        url: Url,
        name: ItemLabel,
        isLast: index === breadcrumbsLength - 1
      }), index !== breadcrumbsLength - 1 && /*#__PURE__*/_jsx(StyledArrowRightThin, {})]
    }, Url))
  });
};
//# sourceMappingURL=Breadcrumbs.js.map